/**
 * API path constants aligned with backend routes (src/features/.../routes.ts).
 * Use these so frontend and backend stay in sync.
 */
export const API_PATHS = {
  // Auth (src/features/auth/routes.ts)
  AUTH_LOGIN: "/api/v1/auth/login",
  ACCOUNTS_TOKEN: "/api/v1/accounts/token/",

  // Health (src/features/health/routes.ts)
  HEALTH: "/health",

  // Export (src/features/export/routes.ts)
  EXPORT_DECL: "/api/v1/ezyplus/export-decl/",
  EXPORT_ENTRIES: "/api/v1/export-entries",
  EXPORT_ENTRIES_BY_ID: (id: string) => `/api/v1/export-entries/${id}`,
  VALIDATE_DECL: "/api/v1/ezyplus/validate-decl/",
  CALCULATE: "/api/v1/calculate/",
  PRINT_DOCUMENT: "/api/v1/export/print-document/",
  SEND_EXPORT_DECL: "/api/v1/export/send-export-decl/",
  EXPORT_ENTRIES_SUBMIT: (id: string) => `/api/v1/export-entries/${id}/submit`,

  // GCL (src/features/gcl/routes.ts)
  GCL_ENTRIES: "/api/v1/gcl-entries",
  GCL_CREATE_UPDATE: "/api/v1/goodcontrol/create-update-gcl/",

  // Short (src/features/short/routes.ts)
  SHORT_ENTRIES: "/api/v1/short-entries",
  SHORT_CREATE_UPDATE: "/api/v1/short/create-update-short/",

  // Cancel (src/features/cancel/routes.ts)
  CANCEL_DOCUMENT: "/api/v1/cancel/cancel-document/",

  // XML (src/features/xml/routes.ts)
  GET_XML: "/api/v1/getxml",

  // Webhooks – TIFFA (src/features/webhook/routes.ts). Spec path: /api/v1/webhooks/tiffa/update-status
  WEBHOOKS_SEND_MOCK: "/api/v1/tiffa/webhooks/send-mock",
  WEBHOOKS_RECEIVED: "/api/v1/tiffa/webhooks/received",
  WEBHOOKS_TIFFA_UPDATE: "/api/v1/webhooks/tiffa/update-status",
  TIFFA_WEBHOOKS: "/api/v1/tiffa/webhooks",
  TIFFA_WEBHOOK_RETRY: (id: string) => `/api/v1/tiffa/webhooks/${id}/retry`,

  // Liner (src/features/liner/routes.ts)
  DCSA_BOOKING: "/api/dcsa-booking",
  LINER_WEBHOOKS_DEFAULTS: "/api/v1/liner/webhooks/defaults",
  LINER_WEBHOOKS_SEND_MOCK: "/api/v1/liner/webhooks/send-mock",

  // Simulation config (src/features/config/routes.ts)
  SIMULATION_CONFIG: "/api/v1/simulation-config",

  // TCC (src/features/tcc/routes.ts) — /tcc-co-api prefix
  TCC_LOGIN: "/tcc-co-api/api/logintcc",
  TCC_GET_USER_PROFILE: "/tcc-co-api/api/getUserProfile",
  TCC_GET_LIST_ATTACH_TYPE: "/tcc-co-api/api/getListAttachType",
  TCC_GET_LIST_BRANCH: "/tcc-co-api/api/getListBranch",
  TCC_GET_LIST_COUNTRY: "/tcc-co-api/api/getListCountry",
  TCC_GET_LIST_VESSEL_TYPE: "/tcc-co-api/api/CO/getListVesselType",
  TCC_GET_RELATION_COMPANY: "/tcc-co-api/api/CO/getRelationCompany",
  TCC_GET_DECLARATOR_CO: "/tcc-co-api/api/CO/getDeclaratorCO",
  TCC_GET_USER_ADDRESS: "/tcc-co-api/api/getUserAddress",
  TCC_GET_LIST_NAME_LASTNAME: "/tcc-co-api/api/CO/getListNameLastname",
  TCC_GET_LIST_UNIT: "/tcc-co-api/api/getListUnit",
  TCC_GET_LIST_WEIGHT: "/tcc-co-api/api/getListWeight",
  TCC_EXCHANGE_RATE_MAX_DATE: "/tcc-co-api/api/mst/exchangeratemaxdate",
  TCC_GET_HARMONIZED_CODE: "/tcc-co-api/api/getHarmonizedCode",
  TCC_GET_LIST_DOC: "/tcc-co-api/api/getListDoc",
  TCC_GET_MASTER_STATUS_LIST: "/tcc-co-api/api/getMasterStatusList",
  TCC_GET_QUEUE_COUNT: "/tcc-co-api/api/getQueueCount",
  TCC_SAVE_CO: "/tcc-co-api/api/CO/saveCO",
  TCC_SAVE_CF: "/tcc-co-api/api/saveCF",
  TCC_GET_CO: "/tcc-co-api/api/getCO",
  TCC_GET_CF_DETAIL: "/tcc-co-api/api/getCFDetail",
  TCC_CANCEL_VERIFY: "/tcc-co-api/api/cancelVerify",
  TCC_DELETE_CO: "/tcc-co-api/api/deleteCO",
  TCC_LIST_DOCUMENTS: "/tcc-co-api/api/getListDocumentCOCFExternal",
  TCC_GET_PREVIEW_CO_PACK: "/tcc-co-api/api/getPreviewCOPack",
  TCC_UPLOAD_BATCH_IMAGE: "/tcc-co-api/api/uploadBatchImage",
  TCC_PAYMENT_LIST: "/tcc-co-api/api/paymentListGetByPackId",
  TCC_LOG_PRINT_HISTORY: "/tcc-co-api/api/LogPrintHistory",
  TCC_GET_ERROR_MARK: "/tcc-co-api/api/getErrorMark",
  TCC_MESSAGE_FROM_CO: "/tcc-co-api/api/messageFromCo",
  TCC_MESSAGE_LOG: "/tcc-co-api/api/tcc/messageLog",

  // SAP (src/features/sap/routes.ts)
  SAP_HEALTH: "/http/ffocean/health",
  SAP_CREATE_SO: "/http/ffocean/createSO",
  SAP_UPDATE_SO: "/http/ffocean/updateSO",
  SAP_CONFIG: "/api/v1/sap/config",
  SAP_SALES_ORDERS: "/api/v1/sap/sales-orders",
  SAP_OUTBOUND_WEBHOOKS: "/api/v1/sap/outbound-webhooks",
  SAP_WEBHOOK_SEND_CONTRACT: "/api/v1/sap/webhooks/send-contract",
  SAP_WEBHOOK_SEND_SALES_ORDER: "/api/v1/sap/webhooks/send-sales-order",
  SAP_DEFAULT_CONTRACT_PAYLOAD: "/api/v1/sap/defaults/contract-payload",
  SAP_DEFAULT_SO_PAYLOAD: "/api/v1/sap/defaults/sales-order-payload",
} as const;
